import { registerSchema } from "yage/components/ComponentRegistry";
import { Component, Schema } from "yage/decorators/type";

@Component("StructureType")
export class StructureTypeSchema extends Schema {}

registerSchema(StructureTypeSchema);
